import { defineStore } from 'pinia'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import { ref } from 'vue'
import { CookiesSettingObject } from '@/types'
import { yandexMetrika } from '@/services/yandexMetrika'
import { trackSiteVisit } from '@/services/metrikaGoals'
import AppConfig from '@/config'

export const useCookiesStore = defineStore('cookies', () => {
	const showCookiesDialog = ref(false)
	const needShowCookiesDialog = ref(false)
	const showCookiesSettings = ref(false)
	const cookiesSetting = ref<CookiesSettingObject>({
		tech: true,
		// Тумблер восстанавливаем из сохранённого согласия, иначе после перезагрузки
		// он показывал бы «выключено» даже принявшему пользователю.
		analytics: yandexMetrika.analyticsConsent
	})

	function enableAnalyticsCookies() {
		cookiesSetting.value.analytics = true
	}

	function disableAnalyticsCookies() {
		cookiesSetting.value.analytics = false
	}

	function setCookiesDialogShown() {
		localStorage.setItem(STORAGE_KEYS.COOKIES_DIALOG_SHOWN, 'true')
	}

	function toggleAnalyticalCookies() {
		cookiesSetting.value.analytics = !cookiesSetting.value.analytics
	}

	function hideCookiesDialog() {
		showCookiesDialog.value = false
	}

	function openCookiesSettings() {
		// Открываем настройки всегда на фактически сохранённом согласии, а не на
		// черновике, который пользователь бросил в прошлый раз.
		resetCookiesSettings()
		showCookiesSettings.value = true
		showCookiesDialog.value = false
	}

	function hideCookiesSettings() {
		showCookiesSettings.value = false
	}

	// Тумблер в настройках — черновик: он расходится с сохранённым согласием, пока
	// пользователь не нажал «Принять». Закрытие без сохранения черновик отменяет,
	// иначе диалог показывал бы выбор, который фактически не применён.
	function resetCookiesSettings() {
		cookiesSetting.value.analytics = yandexMetrika.analyticsConsent
	}

	function saveCookiesSettings() {
		yandexMetrika.setEnabled(cookiesSetting.value.analytics)
		// Визит при загрузке страницы ушёл в пустоту, если согласия ещё не было — досылаем.
		// Дедупликация по вкладке не даст отправить его второй раз.
		if (cookiesSetting.value.analytics) trackSiteVisit()
	}

	// Спрашиваем всех, включая гостей, но только там, где есть счётчик (в tcell его нет).
	function checkAndShowCookiesDialog() {
		const currentPath = window.location.pathname

		showCookiesDialog.value =
			!!AppConfig.yaMetrikaId &&
			localStorage.getItem(STORAGE_KEYS.COOKIES_DIALOG_SHOWN) === null &&
			!currentPath.includes('cookie-policy')
		needShowCookiesDialog.value = showCookiesDialog.value
	}

	return {
		showCookiesDialog,
		needShowCookiesDialog,
		showCookiesSettings,
		cookiesSetting,
		enableAnalyticsCookies,
		disableAnalyticsCookies,
		setCookiesDialogShown,
		toggleAnalyticalCookies,
		hideCookiesDialog,
		openCookiesSettings,
		hideCookiesSettings,
		resetCookiesSettings,
		saveCookiesSettings,
		checkAndShowCookiesDialog
	}
})
